$(document).ready(function () {
	const video = $('#video')[0];

	if (!video) {
		return;
	}

	const options = {
		root:      null,
		threshold: 0.25
	};

	const observer = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				video.play();
			}
			else {
				video.pause();
			}
		});
	}, options);

	observer.observe(video);
});
